/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UnshareSkillRequestBody = {
  /**
   * The skill ID.
   */
  skillId: string;
};

/** @internal */
export type UnshareSkillRequestBody$Outbound = {
  skill_id: string;
};

/** @internal */
export const UnshareSkillRequestBody$outboundSchema: z.ZodMiniType<
  UnshareSkillRequestBody$Outbound,
  UnshareSkillRequestBody
> = z.pipe(
  z.object({
    skillId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      skillId: "skill_id",
    });
  }),
);

export function unshareSkillRequestBodyToJSON(
  unshareSkillRequestBody: UnshareSkillRequestBody,
): string {
  return JSON.stringify(
    UnshareSkillRequestBody$outboundSchema.parse(unshareSkillRequestBody),
  );
}
